module.exports = __webpack_public_path__ + "img/54.9cc635b.jpg";